module.exports = __webpack_public_path__ + "fonts/notosans-regular-web.47a5c0a.ttf";